import * as React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { ListItem } from './ListItem';
import { ListItemIcon } from './ListItemIcon';
import { ListItemText } from './ListItemText';
import { NavLink } from '../NavLink';
import { NavLinkProps } from 'react-router-dom';
import { withTheme, WithTheme } from '@material-ui/core/styles';

export type OwnProps = {
  inset?: boolean;
  icon?: JSX.Element;
  tooltip?: boolean;
  divider?: boolean;
};

export type Props = OwnProps & NavLinkProps & WithTheme;

const NavLinkListItemComponent: React.FC<Props> = ({
  theme: { spacing },
  inset,
  icon,
  tooltip,
  divider,
  children,
  ...navLinkProps
}) => {
  const Link = React.useMemo(
    () =>
      React.forwardRef<HTMLAnchorElement, Omit<NavLinkProps, 'to'>>((listItemProps, ref) => (
        <NavLink ref={ref} {...navLinkProps} {...listItemProps}>
          {icon && (
            <ListItemIcon
              style={
                inset
                  ? {
                      margin: `0 -${spacing() / 2}px 0 ${spacing(4)}px`
                    }
                  : undefined
              }
            >
              {icon}
            </ListItemIcon>
          )}
          <ListItemText
            inset={inset}
            primaryTypographyProps={{
              noWrap: true
            }}
          >
            {listItemProps.children}
          </ListItemText>
        </NavLink>
      )),
    [icon, inset, navLinkProps, spacing]
  );

  const listItem = (
    <ListItem button divider={divider} component={Link}>
      {children}
    </ListItem>
  );

  return tooltip ? (
    <Tooltip title={<React.Fragment>{children}</React.Fragment>} placement="right">
      {listItem}
    </Tooltip>
  ) : (
    listItem
  );
};

export const NavLinkListItem = withTheme(NavLinkListItemComponent);
